import React, { useState, useEffect } from 'react';
import api from "../../api";
import EmployeeUserTable from '../../components/UserTable/EmployeeUserTable';
import StatCard from '../../components/Profile/StatCard ';
import {toPersianNumbers} from "../../utils/toPersianNumbers";
import {Link} from "react-router-dom";
import { exportToExcel } from "../../utils/exportToExcel"; // import تابع جدید
import Button from "../../components/Button";


export default function EmployeeUserManagement() {
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [totalUsers, setTotalUsers] = useState(0);
  const [activeUsers, setActiveUsers] = useState(0);
  const [newUsersLast7Days, setNewUsersLast7Days] = useState(0);


  useEffect(() => {
    fetchUsers();
  }, []);

const fetchUsers = async () => {
  try {
    setLoading(true);
    const response = await api.get('accounts/admin/users/employees/');
    const data = Array.isArray(response.data) ? response.data : [];
    setProfiles(data);

    // ۱️⃣ تعداد کل
    setTotalUsers(data.length);

    // ۲️⃣ تعداد فعال‌ها
    const activeCount = data.filter((p) => p.is_active).length;
    setActiveUsers(activeCount);

    // ۳️⃣ کاربران جدید ۷ روز اخیر
    const oneWeekAgo = new Date();
    oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);

    const newCount = data.filter((p) => {
      if (!p.date_joined) return false;
      const joinedDate = new Date(p.date_joined);
      return joinedDate >= oneWeekAgo;
    }).length;
    setNewUsersLast7Days(newCount);

  } catch (err) {
    setError('خطا در بارگذاری لیست کاربران');
    console.error(err);
  } finally {
    setLoading(false);
  }
};
 const handleExportExcel = () => {
    if (!profiles.length) {
      alert("داده‌ای برای خروجی وجود ندارد");
      return;
    }
    exportToExcel(profiles, "لیست_شرکت کارمندان", {
      headers: {
        full_name: "نام و نام خانوادگی",
        employee_code: "کد پرسنلی",
        phone_number: "موبایل",
        is_active: "وضعیت",
        date_joined: "تاریخ ثبت‌نام",
      },
    });
  };
  return (
      <div className="p-6">
        {/* خطا */}
        {error && (
            <div className="mb-4 text-red-600">
              {error}
            </div>
        )}

        {/* کارت‌های آمار */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
          <StatCard title={'تعداد کل کاربران'} value={toPersianNumbers(totalUsers)}/>
          <StatCard title={'کاربران فعال'} value={toPersianNumbers(activeUsers)}/>
          <StatCard title={'کاربران جدید (۷ روز گذشته)'} value={toPersianNumbers(newUsersLast7Days)}/>
        </div>

        <div className="flex justify-end sm:grid-cols-3 gap-4 mb-6">
          <Link
              to="/admin-user-register/"
              state={{ role: 'admin' }}
              className="px-4 py-2 bg-[#1E3A5F] text-[#FFC107] rounded-md hover:bg-[#2B5388] hover:text-[#D19D00] transition duration-200 whitespace-nowrap"
          >
            ثبت نام کارمند جدید
          </Link>

            <Button
                variant={'secondary'}
                onClick={handleExportExcel}
                children={'خروجی اکسل'}
                />

        </div>
        <div>
          <EmployeeUserTable profiles={profiles} loading={loading}/>
        </div>
      </div>
  );
};